import React from 'react';
import ArchiveList from '../../components/Archive';

export default function ArchivePage(){
  return (
    <div className="container">
      <ArchiveList />
    </div>
  );
}
